<template>
  <v-navigation-drawer
    app
    width="256"
    class="ideaverse-black--background"
  >
    <!-- ------------ Heading ------------ -->
    <div class="pa-4">
      <div class="d-flex flex-row align-center white--text">
        <img src="@/assets/logo.png" class="pointer mr-3" @click="go('LandingView')" width="38" height="38">
        <div class="d-flex flex-column">
          <div class="d-flex flex-row">
            <h1 class="cal-sans-regular pointer" @click="go('LandingView')">IDEAVERSE</h1>
            <div class="mb-3">&trade;</div>
          </div>
          <div class="font-size-12">
            Administration Zone
          </div>
        </div>
      </div>
    </div>
    
    <v-divider class="grey darken-3" ></v-divider>
    <div class="flex-1">
      <v-list>
        <v-list-item v-for="item in menu" :key="item.route" class="white--text" link @click="go(item.route)">
          <v-list-item-icon>
            <v-icon :color="isActive(item.route) ? 'white' : 'grey'">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
    <div class="grey--text text-caption text-center py-2">
      &copy; {{ year }} Ideaverse (v{{ version }} {{ codename }}).
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AdminSidebar',
  data() {
    return {
      version: '',
      codename: '',
      year: '',
      menu: [
        {
          name: 'Dashboard',
          route: 'AdminDashboard',
          icon: 'mdi-home',
        },
        {
          name: 'Users',
          route: 'AdminUsers',
          icon: 'mdi-account',
        },
        {
          name: 'Realms',
          route: 'AdminRealms',
          icon: 'mdi-earth',
        },
        {
          name: 'Conundrums',
          route: 'AdminConundrums',
          icon: 'mdi-brain',
        },
        {
          name: 'Usernames',
          route: 'AdminUsernames',
          icon: 'mdi-tag-outline',
        },
        {
          name: 'Cocoro',
          route: 'AdminCocoro',
          icon: 'mdi-robot',
        },
      ]
    }
  },
  created() {
    this.version = process.env.VUE_APP_VERSION
    this.codename = process.env.VUE_APP_CODENAME
    this.year = new Date().getFullYear()
  },
  methods: {
    isActive(route) {
      return this.$route.name === route
    }
  }
}
</script>

<style scoped>
::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
</style>